export default function ValueBadge({ cpp, size = 'md' }) {
  const color = cpp >= 2 ? 'bg-teal/20 text-teal' : cpp >= 1 ? 'bg-gold/20 text-gold' : 'bg-danger/20 text-danger';
  const sizeClass = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';
  return (
    <span className={`${color} ${sizeClass} rounded-full font-semibold inline-flex items-center gap-1`}>
      {cpp?.toFixed(1)}cpp
    </span>
  );
}
